// extracted by mini-css-extract-plugin
export default {"cargando":"MensajeCargando_cargando__yNgGx"};